import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    value: null,
};

export const signatureIdDetails = createSlice({
    name: 'signature_id',
    initialState,
    reducers: {
        signatureIdDetail: (state, action) => {
            state.value = action.payload;
        },
    },
});

export const { signatureIdDetail } = signatureIdDetails.actions;

export default signatureIdDetails.reducer;